export enum PermissionConsts {
    // Pages
    Pages_Tenants = 'PagesTenants',
    Pages_Roles = 'PagesRoles',
    Pages_Users = 'PagesUsers',
    Pages_Users_Activation = 'PagesUsersActivation',
    PagesMyProfileCompany = 'PagesMyProfileCompany',
    PagesMyProfileCooperative = 'PagesMyProfileCooperative',

    // Users
    User_RequestEmailConfirmation = 'UserRequestEmailConfirmation',
    User_Create = 'UserCreate',
    User_Edit = 'UserEdit',
    User_Delete = 'UserDelete',
    User_ForceResetPassword = 'UserForceResetPassword',
    User_Deactivate = 'UserDeactivate',
    User_UnlockLogin = 'UserUnlockLogin',
    User_GetMyProfile = 'UserGetMyProfile',
    User_UpdateMyProfile = 'UserUpdateMyProfile',

    // Files
    FileCreate = 'FileCreate',
    FileDelete = 'FileDelete',
    FileGetAll = 'FileGetAll',
    FileGet = 'FileGet',

    // Certificates
    CertificateCreate = 'CertificateCreate',
    CertificateUpdate = 'CertificateUpdate',
    CertificateDelete = 'CertificateDelete',
    CertificateGetAll = 'CertificateGetAll',
    CertificateGet = 'CertificateGet',

    // Beneficiaries
    BeneficiaryCreate = 'BeneficiaryCreate',
    BeneficiaryUpdate = 'BeneficiaryUpdate',
    BeneficiaryDelete = 'BeneficiaryDelete',
    BeneficiaryGetAll = 'BeneficiaryGetAll',
    BeneficiaryGet = 'BeneficiaryGet',

    // Services
    ServiceCreate = 'ServiceCreate',
    ServiceUpdate = 'ServiceUpdate',
    ServiceDelete = 'ServiceDelete',
    ServiceGetAll = 'ServiceGetAll',
    ServiceGet = 'ServiceGet',

    // InterventionAreas
    InterventionAreaCreate = 'InterventionAreaCreate',
    InterventionAreaUpdate = 'InterventionAreaUpdate',
    InterventionAreaDelete = 'InterventionAreaDelete',
    InterventionAreaGetAll = 'InterventionAreaGetAll',
    InterventionAreaGet = 'InterventionAreaGet',

    // Requests
    RequestCreate = 'RequestCreate',
    RequestUpdate = 'RequestUpdate',
    RequestDelete = 'RequestDelete',
    RequestGetAll = 'RequestGetAll',
    RequestGet = 'RequestGet',
    MarkCompanyContactedByCooperative = 'MarkCompanyContactedByCooperative',
    ConfirmCompanyContact = 'ConfirmCompanyContact',
    SendCooperativeReminder = 'SendCooperativeReminder',

    // Notifications
    NotificationsView = 'NotificationsView',
    NotificationsCreate = 'NotificationsCreate',

    // FrameworkAgreement
    FrameworkAgreement_Create = 'FrameworkAgreementCreate',
    FrameworkAgreement_Update = 'FrameworkAgreementUpdate',
    FrameworkAgreement_Delete = 'FrameworkAgreementDelete',
    FrameworkAgreement_GetAll = 'FrameworkAgreementGetAll',
    FrameworkAgreement_Get = 'FrameworkAgreementGet',
    FrameworkAgreement_DownloadForSigning = 'FrameworkAgreementDownloadForSigning',
    FrameworkAgreement_UploadSigned = 'FrameworkAgreementUploadSigned',

    // Jobs
    JobCreate = 'JobCreate',
    JobUpdate = 'JobUpdate',
    JobDelete = 'JobDelete',
    JobGetAll = 'JobGetAll',
    JobGet = 'JobGet',

    // UserFiles
    UserFileCreate = 'UserFileCreate',
    UserFileUpdate = 'UserFileUpdate',
    UserFileDelete = 'UserFileDelete',
    UserFileGetAll = 'UserFileGetAll',
    UserFileGet = 'UserFileGet',

    // Employees
    EmployeeCreate = 'EmployeeCreate',
    EmployeeUpdate = 'EmployeeUpdate',
    EmployeeDelete = 'EmployeeDelete',
    EmployeeGetAll = 'EmployeeGetAll',
    EmployeeGet = 'EmployeeGet',

    // JobFiles
    JobFileCreate = 'JobFileCreate',
    JobFileUpdate = 'JobFileUpdate',
    JobFileDelete = 'JobFileDelete',
    JobFileGetAll = 'JobFileGetAll',
    JobFileGet = 'JobFileGet',

    //DocumentFolder
    DocumentFolderCreate = 'DocumentFolderCreate',
    DocumentFolderUpdate = 'DocumentFolderUpdate',
    DocumentFolderDelete = 'DocumentFolderDelete',
    DocumentFolderGetAll = 'DocumentFolderGetAll',
    DocumentFolderGet = 'DocumentFolderGet',

    // IncludoAI
    IncludoAIQuery = 'IncludoAIQuery',
    IncludoAIIngest = 'IncludoAIIngest',
}
